import { Component, Input, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-prensa-listing-block',
  templateUrl: './prensa-listing-block.component.html',
  styleUrls: ['./prensa-listing-block.component.css']
})
export class PrensaListingBlockComponent implements OnInit {

  @Input() prensaBlock_item: any = {}
  datepipe: DatePipe = new DatePipe('es-ES')
  fecha: string | null = ''
  img: any;
  constructor() {
  }

  ngOnInit(): void {
    this.fecha = this.prensaBlock_item.date
    this.fecha = this.datepipe.transform(this.fecha, 'dd MMMM yyyy')
    this.img = 'https://' + this.prensaBlock_item.imageSalaUrl
  }

}
